// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountSaveUserRoleDefaultResponse {
    static getAttributeTypeMap() {
        return AccountSaveUserRoleDefaultResponse.attributeTypeMap;
    }
}
AccountSaveUserRoleDefaultResponse.discriminator = undefined;
AccountSaveUserRoleDefaultResponse.additionalProperties = false;
AccountSaveUserRoleDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "string"
    },
];
//# sourceMappingURL=accountSaveUserRoleDefaultResponse.js.map